import { render, staticRenderFns } from "./ProfileCardDetailsSection.vue?vue&type=template&id=09c48c7a"
import script from "./ProfileCardDetailsSection.vue?vue&type=script&lang=js"
export * from "./ProfileCardDetailsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports